module.exports = __webpack_public_path__ + "static/media/card-bulleted-settings-outline.9309a58a.svg";